import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { useDbPoolStore } from "@/stores/adminStore"

export function PoolStatus() {
  const { pool_size, checked_in, checked_out, overflow } = useDbPoolStore()
  const metrics = [
    {
      label: "Pool Size",
      description: "Total number of connections in the pool",
      value: pool_size,
      color: "bg-blue-500",
    },
    {
      label: "Checked In",
      description: "Available connections ready to be used",
      value: checked_in,
      color: "bg-green-500",
    },
    {
      label: "Checked Out",
      description: "Connections currently in use",
      value: checked_out,
      color: "bg-amber-500",
    },
    {
      label: "Overflow",
      description: "Extra connections beyond the pool size",
      value: overflow,
      color: "bg-red-500",
    },
  ]

  return (
    <TooltipProvider delayDuration={100}>
      <div className="flex items-center gap-3 text-sm">
        {metrics.map((metric) => (
          <Tooltip key={metric.label}>
            <TooltipTrigger asChild>
              <div className="flex cursor-help items-center gap-1.5">
                <span className={`h-2 w-2 rounded-full ${metric.color}`} />
                <span className="font-medium">{metric.value}</span>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-sm font-bold">{metric.label}</p>
              <p className="text-xs">{metric.description}</p>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  )
}
